import { render } from "./Raqamlashtirish.vue?vue&type=template&id=517f0d93"
import script from "./Raqamlashtirish.vue?vue&type=script&lang=js"
export * from "./Raqamlashtirish.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__